import { useMutation } from '@tanstack/react-query';
import { IAccount, IAddress } from '../../../extViewmodels';
import { useUserSession } from '../../../models/hooks/appStateHooks';

export interface IUpdateAddressRequest {
	accountId: string;
	address: IAddress;
}

export function useAdminAccountAddressMutation() {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (request: IUpdateAddressRequest) => {
			return userSession.webServiceHelper.callAsync<IAccount>(
				`admin/account/${request.accountId}/address`,
				'PATCH',
				request.address
			);
		},
	});
}
